/**
 * Single source of truth for vendor schedule slot definitions (Morning, Afternoon, Evening).
 * Used by generateServiceWindows, TimeSelectionStep, PARTS_NEEDED_TIME_OPTIONS, and schedule display helpers.
 */
export type ServiceWindow = {
  technicianUUID: string;
  startTime: string;
  endTime: string;
  onHours: boolean;
};

export const SCHEDULE_SLOT_KEYS = {
  MORNING: 'morning',
  AFTERNOON: 'afternoon',
  EVENING: 'evening',
} as const;

export type ScheduleSlotKeyType = (typeof SCHEDULE_SLOT_KEYS)[keyof typeof SCHEDULE_SLOT_KEYS];

export const SCHEDULE_SLOT_DEFINITIONS = [
  {
    key: SCHEDULE_SLOT_KEYS.MORNING,
    startHour: 8,
    endHour: 12,
    label: 'Morning',
    timeLabel: '8 AM - 12 PM',
  },
  {
    key: SCHEDULE_SLOT_KEYS.AFTERNOON,
    startHour: 12,
    endHour: 16,
    label: 'Afternoon',
    timeLabel: '12 PM - 4 PM',
  },
  {
    key: SCHEDULE_SLOT_KEYS.EVENING,
    startHour: 16,
    endHour: 20,
    label: 'Evening',
    timeLabel: '4 PM - 8 PM',
  },
] as const;

/** Hour (0–23) → period label from slot definitions. Uses same bounds as SCHEDULE_SLOT_DEFINITIONS. */
export const getPeriodOfDayFromHour = (hour: number): string => {
  const slot = SCHEDULE_SLOT_DEFINITIONS.find(
    (s) => hour >= s.startHour && hour < s.endHour,
  );
  return slot?.label ?? 'Time';
};
